import { SliceComponentProps, graphql } from "gatsby";
import React from "react";
import { AdditionalNavBarProps, BaseSliceContext } from "./types";
import SliceProviders from "./SliceProviders";
import { toValidatedTopMenuItems } from "components/HeaderNavBar/MegaMenu/utils";
import MenuLight from "components/HeaderNavBar/MenuLangingPage";
import { LightNavBarV2Query } from "types/graphql-types";

const LightNavBarV2: React.FC<
  SliceComponentProps<
    LightNavBarV2Query,
    BaseSliceContext,
    AdditionalNavBarProps
  >
> = ({ data, sliceContext, hideRaqCTA }) => {
  const validatedTopMenuItems = hideRaqCTA
    ? []
    : toValidatedTopMenuItems(data.topMenu?.items || []);
  const links = validatedTopMenuItems.filter((l) => l.specialType == "raq");

  return (
    <SliceProviders languageCode={sliceContext.languageCode}>
      <MenuLight topLinks={links} showLinksOnMobile />
    </SliceProviders>
  );
};

// eslint-disable-next-line import/no-unused-modules
export const query = graphql`
  query LightNavBarV2 {
    topMenu: sanityTopMenu(_id: { in: ["top-menu", "drafts.top-menu"] }) {
      items {
        ...TopMenuItem
      }
    }
  }
`;

export default LightNavBarV2;
